(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["best-selling"] && !Shopify.designMode) return;
  try {
    

// form a brands slider with slick


$(document).ready(function() {
    $('.best-selling-inner1').css("display", "block");
    $('.brands-responsive1').slick({
    dots: false,
    infinite: true,
    autoplay: false,
   
    slidesToShow: 4,
    slidesToScroll: 1,    
    appendArrows: $('.news__arrows'),
    prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style="">Previous</button>',
    nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style="">Next</button>',
 	arrows: true,
    responsive: [
       {
        breakpoint: 820,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true
        }
      },
      
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:

    ]
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brands_slider"] && !Shopify.designMode) return;
  try {
    

// form a brands slider with slick
$(document).ready(function() {
 $('#brandSliderCol').css("display", "block");
  $('.brands-responsive').slick({ 
    rows: 1,
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 6,
    slidesToScroll: 6,
 	arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 6, 
          infinite: true
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
       	  arrows: false
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
       	  arrows: false
        }
      }
      // You can unslick at a given breakpoint now by adding:

    ]
  });
});  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related_products"] && !Shopify.designMode) return;
  try {
    

// form a brands slider with slick
  $('.brands-responsive1').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,    
    appendArrows: $('.news__arrows'),
    prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style="">Previous</button>',
    nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style="">Next</button>',
 	arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:

    ]
  });
  

  } catch(e) { console.error(e); }
})();
})();
